import script from "./KeyValues.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyValues.vue?vue&type=script&setup=true&lang=ts"

import "./KeyValues.vue?vue&type=style&index=0&id=4324c817&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4324c817"]])

export default __exports__